import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router.js'
import i18n from './i18n.js'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
// import './style.css'
import App from './App.vue'
import { API_CONFIG, apiCall } from './utils/api.js'

// Carica la configurazione del LocalBackend all'avvio
async function loadLocalBackendConfig() {
  try {
    const config = await apiCall('/api/config/config', {
      method: 'GET',
      backend: 'local',
      includeAuth: false
    })
    
    if (config && config.localBackendUrl) {
      API_CONFIG.localBackend = config.localBackendUrl
      console.log('LocalBackend URL caricato:', config.localBackendUrl)
    }
  } catch (error) {
    // Non blocchiamo l'avvio se il LocalBackend non è disponibile
    console.warn('LocalBackend non disponibile, uso configurazione predefinita')
  }
}

const vuetify = createVuetify({
  components,
  directives,
})

const app = createApp(App)

const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vuetify)

// Prova a caricare la configurazione ma non bloccare l'avvio
loadLocalBackendConfig().finally(() => {
  app.mount('#app')
})
